define("Magento_Translation/js/mage-translation-dictionary",["text!js-translation.json"],(function(n){"use strict";return JSON.parse(n||"[]")}));
